import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface FormModalUploadState {
  step?: number;
  typeDocuments?: string;
}

const FormModalUploadInitialState: FormModalUploadState = { step: 1 };

// Slice
export const root = createSlice({
  name: 'form',
  initialState: {
    IsLoading: false,
    ShowSideBar: false, // show/hide side bar
    FormStage: 1, // default page stage to show on page load
    ShowModalUpload: false,
    AssetsUploaded: [],
    FormModalUpload: FormModalUploadInitialState,
  },
  reducers: {
    formStage: (state, action) => {
      state.FormStage = action.payload;
    },
    isLoading: (state, action) => {
      state.IsLoading = action.payload;
    },
    showSideBar: (state, action) => {
      state.ShowSideBar = action.payload;
    },
    showModalUpload: (state, action) => {
      state.ShowModalUpload = action.payload;
    },
    assetsUploaded: (state, action) => {
      state.AssetsUploaded = action.payload;
    },
    formModalUpload: (state, action: PayloadAction<FormModalUploadState>) => {
      state.FormModalUpload = { ...state.FormModalUpload, ...action.payload };
    },
  },
});

// Actions
export const { isLoading, assetsUploaded, formStage, showSideBar, formModalUpload, showModalUpload } =
  root.actions;
